;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'clsx';
import PropTypes from 'prop-types';

import CarouselProvider from 'components/ui/CarouselProvider';

import { blockRootProps } from 'utils';

import OverflowCarousel from './OverflowCarousel';

import styles from './BlockOverflowCarousel.module.scss';

const BlockOverflowCarousel = ({
    __typename,
    slides,
    extendedTopPadding,
    anchorId,
    flushTop,
    flushBottom,
    firstBlock,
}) => {
    flushTop ??= false;
    flushBottom ??= false;

    return (
        <div
            className={cx(styles.blockRoot, {
                [styles.isExtendedTop]: extendedTopPadding,
                [styles.flushTop]: flushTop,
                [styles.flushBottom]: flushBottom,
            })}
            {...blockRootProps(anchorId, __typename)}
        >
            <CarouselProvider slides={slides} firstBlock={firstBlock}>
                <OverflowCarousel firstBlock={firstBlock} />
            </CarouselProvider>
        </div>
    );
};

BlockOverflowCarousel.propTypes = {
    __typename: PropTypes.string,
    slides: PropTypes.array,
    extendedTopPadding: PropTypes.bool,
    anchorId: PropTypes.string,
    flushTop: PropTypes.bool,
    flushBottom: PropTypes.bool,
    firstBlock: PropTypes.bool,
};

export default BlockOverflowCarousel;
